import React from 'react'
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import DatePicker from '../Components/DatePicker'
import { DepositHeader } from '../index'
import TipsView from '../Components/TipsView'
import UploadFile from '../Components/UploadFile'
import Modal from '../Components/Modal'
import CopyView from '../Components/CopyView'
import NextStepCon from '$Deposits/Components/LB/NextStep'
import LBOfflineRefNo from '../Components/LBOfflineRefNo'
import SubmitBtn from '../Components/SubmitBtn'

class NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }


    render() {


        return (
            <>
                <NextStepCon
                    // 无法存款提示
                    Modal={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                okText={okText}
                                onOk={onChange}
                            >
                                <>
                                    <div className='titleIcon'>
                                        <span className='warningIcon imgIcon' />
                                    </div>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}
                    // 图片错误提示
                    FileModal={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                okText={okText}
                                onOk={onChange}
                            >
                                <>
                                    <div className='titleIcon'>
                                        <span className='warningIcon imgIcon' />
                                    </div>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}
                    NextStep={(propCon) => {
                        const {
                            DepositBankActive,
                            MethodsActive,
                            backClick,
                            onChange,
                            DepositMoneyStatus,
                            DepositAccountByAmount,
                            submitBtn
                        } = propCon
                        const { money } = DepositMoneyStatus || {}
                        let { accountHolderName, accountNo, bankName, enBankName, bankCode } = DepositAccountByAmount || {}

                        if (!accountHolderName) {
                            accountHolderName = DepositBankActive.accountHolderName || ' '
                        }
                        if (!accountNo) {
                            accountNo = DepositBankActive.accountNo || ' '
                        }
                        if (!enBankName) {
                            enBankName = DepositBankActive.enBankName || ' ';
                        }
                        return (
                            <div className='nextModal'>
                                <div className='nextModalCenter'>
                                    <TipsView msg={'Sau khi chuyển tiền vào tài khoản ngân hàng của FUN88, hãy cung cấp thông tin gửi tiền của bạn cho chúng tôi theo đơn bên dưới để tạo lệnh gửi tiền.'} />
                                    <div className='viewArea'>
                                        <h4>Thông tin tiền gửi của bạn:</h4>
                                        <div className='borders' />
                                        <div className='amount'>
                                            <span className='amountTitle'>Số Tiền Gửi (1=1,000)</span>
                                            <span className='amountValue'>{numberWithCommas(money)} đ</span>
                                        </div>
                                        <div className='borders' />
                                        <div className='tipsGray'>
                                            Sau khi giao dịch thành công, số tiền <span>{numberWithCommas(money * 1000)}</span> sẽ được cập nhật vào tài khoản của bạn.
                                        </div>
                                    </div>
                                    <div className='viewArea'>
                                        <h4>Ngân Hàng FUN88:</h4>
                                        {/* 银行名称 */}
                                        <CopyView
                                            copyTitle={'Tên Ngân Hàng'}
                                            copyValue={enBankName}
                                            bankCode={bankCode}
                                            copyType={'bankName'}
                                        />
                                        {/* 持有人姓名 */}
                                        <CopyView
                                            copyTitle={'Tên Người Nhận'}
                                            copyValue={accountHolderName}
                                            copyType={'accountHolderName'}
                                        />

                                        {/* 卡号 */}
                                        <CopyView
                                            copyTitle={'Số Tài Khoản'}
                                            copyValue={accountNo}
                                            copyType={'accountNo'}
                                        />
                                    </div>

                                    <div className='viewArea'>
                                        <div className='fun88-bank'><LBOfflineRefNo/></div>
                                        {/* 日期选择 */}
                                        <p className='inputTitle'>Ngày Gửi</p>
                                        <DatePicker
                                            mode={'date'}
                                            titleText={'Chọn Ngày'}
                                        />

                                        {/* 时间选择 */}
                                        <div className='inputTitle time-title-container'>
                                            <p>Thời Gian Gửi</p>
                                            <span className="required-label">Bắt buộc</span>
                                        </div>
                                        <DatePicker
                                            mode={'time'}
                                            titleText={'Chọn Ngày'}
                                        />
                                        {/* 上传图片 */}
                                        <div style={{ paddingTop: 20 }}>
                                            <UploadFile />
                                        </div>
                                    </div>
                                    <SubmitBtn
                                        submitBtn={submitBtn}
                                        onPress={onChange}
                                        submitBtnItem={'Tôi Đã Gửi Tiền Thành Công'}
                                        disabledStyle={{
                                            backgroundColor: "#e3e3e3",
                                            color: "#999999",
                                        }}
                                    />
                                </div>
                            </div>
                        )
                    }}

                />

            </>
        );
    }
}

export default NextStep



